import { Fragment } from 'react';

import { useAppCard } from '../model';

import { Avatar } from './Avatar';
import { UnclaimedBadge } from './UnclaimedBadge';

const Header = () => {
  const { data } = useAppCard();

  return (
    <div className="relative flex items-start justify-between gap-2">
      <div className="space-y-1.5 min-w-0">
        {data.claimed ? (
          <Fragment>
            <div className="font-bold text-base truncate">{data.name}</div>
            <div className="text-xs text-muted-foreground">
              {data.owned ? 'Your application' : 'Vendor application'}
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="font-medium text-base text-muted-foreground">Application name</div>
            <UnclaimedBadge />
          </Fragment>
        )}
      </div>
      <Avatar />
    </div>
  );
};

export { Header };
